import React, { useState, useEffect } from 'react';

const RequestLogs = (props) => {
  const [filters, setFilters] = useState({
    endpoint: '',
    request_type: '',
    ip_address: '',
    response_code: '',
    success: '',
    action: '',
    user_id: '',
    user_type: '',
    request_info: '',
    start_date: '',
    end_date: '',
  });

  const [logs, setLogs] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [logsPerPage] = useState(10);

  useEffect(() => {
    fetchLogs();
    // eslint-disable-next-line
  }, [filters, currentPage]);

  const formatDate = (date) => {
    if (!date) return '';
    const d = new Date(date);
    return d.toISOString().split('T')[0];
  };

  const fetchLogs = async () => {
    const startDateParam = filters.start_date ? `&start_date=${formatDate(filters.start_date)}` : '';
    const endDateParam = filters.end_date ? `&end_date=${formatDate(filters.end_date)}` : '';

    const queryString = `reverse_sort=true&fetch_links=true&limit=${logsPerPage}&skip=${(currentPage - 1) * logsPerPage}${startDateParam}${endDateParam}`;

    const bodyFilters = {
      endpoint: filters.endpoint || undefined,
      request_type: filters.request_type || undefined,
      ip_address: filters.ip_address || undefined,
      response_code: filters.response_code || undefined,
      success: filters.success !== '' ? filters.success === 'true' : undefined,
      action: filters.action !== '' ? filters.action === 'true' : undefined,
      user_id: filters.user_id || undefined,
      user_type: filters.user_type || undefined,
      request_info: filters.request_info || undefined
    };

    Object.keys(bodyFilters).forEach(key => {
      if (bodyFilters[key] === undefined) {
        delete bodyFilters[key];
      }
    });

    var myHeaders = new Headers();
    myHeaders.append("Accept", "application/json");
    myHeaders.append("Authorization", "Bearer " + localStorage.getItem('access_token'));
    myHeaders.append("Content-Type", "application/json");

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      redirect: 'follow',
      body: JSON.stringify(bodyFilters)
    };

    props.tokenSafeAPIRequest('/log/search?' + queryString, requestOptions, '', (result) => {
      if (Array.isArray(result)) {
        setLogs(result);
      } else if (Array.isArray(result.response)) {
        setLogs(result.response);
      } else {
        setLogs([]);
      }
    });
  };

  const handleChange = (e) => {
    setCurrentPage(1); // Reset to first page on filter change
    setFilters({ ...filters, [e.target.name]: e.target.value });
  };

  return (
    <div style={{ padding: '20px' }}>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '10px' }}>
        {Object.keys(filters).map((key) => (
          <div key={key} style={{ display: 'flex', flexDirection: 'column' }}>
            <label htmlFor={key}>{key.replace('_', ' ')}</label>
            <input
              type={key.includes('date') ? 'date' : 'text'}
              id={key}
              name={key}
              placeholder={key}
              value={filters[key]}
              onChange={handleChange}
              style={{ padding: '8px', border: '1px solid #ccc', borderRadius: '4px' }}
            />
          </div>
        ))}
      </div>

      <div style={{ marginTop: '20px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <button type="button" onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))} disabled={currentPage === 1}>
          Previous
        </button>
        <span style={{ margin: '0 10px' }}>Page {currentPage}</span>
        <button type="button" onClick={() => setCurrentPage((p) => p + 1)}>
          Next
        </button>
      </div>

      <div style={{ marginTop: '20px' }}>
        {logs.map((log, index) => (
          <div key={index} style={{ marginBottom: '10px', padding: '10px', border: '1px solid #ddd', borderRadius: '4px' }}>
            <pre>{JSON.stringify(log, null, 2)}</pre>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RequestLogs;
